import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import useLazyQuery from '../../../../modules/react/hooks/useLazyQuery';
import { compose } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';
import { BUILDER } from '../../../../src/shared/abilities';
import { NAME, ID } from './properties';
import FacilitySearchBar from './FacilitySearchBar';

const GET_FACILITIES = gql`
  query GetFacilities($live: Boolean!, $locale: String!) {
    facilities(filter: { live: $live, locale: $locale }){
      edges {
        node {
          id
          ...FacilitySearchBarFacility
        }
      }
    }
  }

  ${FacilitySearchBar.fragments.facility}
`;

const FacilitySearchBarContainer = ({ ...rest }) => {
  const { locale } = useIntl();
  const [focused, setFocused] = useState(false);

  const [query, { loading, data }] = useLazyQuery(
    GET_FACILITIES,
    { variables: { live: true, locale }, ssr: false },
  );

  useEffect(() => {
    if (focused) {
      query();
    }
  }, [focused]);

  const facilities = data?.facilities.edges.map(({ node }) => node) || [];

  return (
    <FacilitySearchBar
      {...rest}
      allFacilities={facilities}
      loadingFacilities={loading}
      setFocused={setFocused}
    />
  );
};

const component = compose(
  connect(state => ({ user: state.user })),
  widget(
    { name: NAME, category: 'Functions', componentId: ID },
    {
      menu: { items: ['delete'] },
    },
  ),
)(FacilitySearchBarContainer);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
